import React, { useEffect, useRef } from 'react';
import Chart from 'chart.js/auto';

const BloodTypeDistribution = ({ distribution }) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  useEffect(() => {
    if (!distribution) return;

    // Prepare data for chart
    const bloodTypes = Object.keys(distribution);
    const counts = Object.values(distribution);
    
    // Blood type colors
    const colors = {
      'A+': 'rgba(220, 38, 38, 0.7)',
      'A-': 'rgba(220, 38, 38, 0.5)',
      'B+': 'rgba(37, 99, 235, 0.7)',
      'B-': 'rgba(37, 99, 235, 0.5)',
      'AB+': 'rgba(79, 70, 229, 0.7)',
      'AB-': 'rgba(79, 70, 229, 0.5)',
      'O+': 'rgba(16, 185, 129, 0.7)',
      'O-': 'rgba(16, 185, 129, 0.5)'
    };

    // Create chart
    if (chartRef.current) {
      // Destroy previous chart if it exists
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
      
      const ctx = chartRef.current.getContext('2d');
      chartInstance.current = new Chart(ctx, {
        type: 'doughnut',
        data: {
          labels: bloodTypes,
          datasets: [
            {
              data: counts,
              backgroundColor: bloodTypes.map(type => colors[type] || `hsl(${Math.random() * 360}, 70%, 60%)`),
              borderColor: 'rgba(255, 255, 255, 0.8)',
              borderWidth: 2,
              hoverOffset: 10
            }
          ]
        },
        options: {
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: 'right',
              labels: {
                padding: 20,
                usePointStyle: true,
                pointStyle: 'circle'
              }
            },
            tooltip: {
              callbacks: {
                label: function(context) {
                  const label = context.label || '';
                  const value = context.raw || 0;
                  const total = context.dataset.data.reduce((a, b) => a + b, 0);
                  const percentage = Math.round((value / total) * 100);
                  return `${label}: ${value} donors (${percentage}%)`;
                }
              }
            }
          },
          cutout: '60%',
          animation: {
            animateScale: true,
            animateRotate: true
          }
        }
      });
    }

    // Cleanup
    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [distribution]);

  if (!distribution) {
    return (
      <div className="flex items-center justify-center h-full">
        <p className="text-gray-500">No blood type distribution data available</p>
      </div>
    );
  }

  return <canvas ref={chartRef} />;
};

export default BloodTypeDistribution;
